/**
 * Statusy odpowiedzi websocketa
 *
 * @export
 * @enum {number}
 */
export enum DocumentWebsocketStatus {
  OK = 'OK',

  LOCKED = 'LOCKED',

  NOT_CONNECTED = 'NOT_CONNECTED'
}
